function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("path", {
  d: "M23.9998 17.3334H17.3332V24.0001C17.3332 24.7334 16.7332 25.3334 15.9998 25.3334C15.2665 25.3334 14.6665 24.7334 14.6665 24.0001V17.3334H7.99984C7.2665 17.3334 6.6665 16.7334 6.6665 16.0001C6.6665 15.2667 7.2665 14.6667 7.99984 14.6667H14.6665V8.00008C14.6665 7.26675 15.2665 6.66675 15.9998 6.66675C16.7332 6.66675 17.3332 7.26675 17.3332 8.00008V14.6667H23.9998C24.7332 14.6667 25.3332 15.2667 25.3332 16.0001C25.3332 16.7334 24.7332 17.3334 23.9998 17.3334Z",
  fill: "#42526E"
});

var SvgIconAdd = function SvgIconAdd(_ref) {
  var svgRef = _ref.svgRef,
      props = _objectWithoutProperties(_ref, ["svgRef"]);

  return React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    ref: svgRef
  }, props), _ref2);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgIconAdd, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/icon-add.abe80de8.svg";
export { ForwardRef as ReactComponent };